var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterMobileCardYellow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 12,
  viewBox: "0 0 13 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.757 6.9V3.512q0-.225-.153-.372a.52.52 0 0 0-.374-.148H5.89a.5.5 0 0 0-.36.148.5.5 0 0 0-.153.372q0 .225.153.372a.5.5 0 0 0 .36.148h2.093L3.52 8.557a.5.5 0 0 0-.152.373q0 .218.152.372a.5.5 0 0 0 .368.155.5.5 0 0 0 .367-.155l4.462-4.524v2.121q0 .225.153.38a.5.5 0 0 0 .367.154.5.5 0 0 0 .367-.154.52.52 0 0 0 .153-.38M1.33 0h10.34q.554 0 .942.393.388.394.388.956v9.302q0 .562-.388.956a1.27 1.27 0 0 1-.942.393H1.33q-.554 0-.942-.393A1.3 1.3 0 0 1 0 10.65V1.35Q0 .787.388.393.777 0 1.33 0"
})));
export default SvgTwitterMobileCardYellow;